import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { Footer } from '../../components/footer';
import { InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { Seo } from '../../components/seo';
import { styled } from '../../styles/stitches.config';

const Contact = () => {
    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    }, []);
    const ContentContainer = styled('section', {
        padding: '80px 0 80px 0',
        maxWidth: '780px',
        margin: '0 auto',
        '@bp1': {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        h1: {
            fontFamily: '$default',
            textAlign: 'center',
            fontSize: '36px',
            marginBottom: '56px',
        },
        h2: {
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.1em',
            margin: '0 0 24px 0',
        },
        p: {
            fontFamily: '$lato',
            color: '#585d6c',
            margin: '0 0 24px 0',
            fontSize: '18px',
            lineHeight: '29px',
        }
    });

    return (
        <Layout>
            <Seo
                title={'Contact Us - Better Days Skin Co.'}
            />
            <ContentContainer>
                <h1>Contact Us</h1>
                <h2>PR &amp; MEDIA</h2>
                <p>If you are interested in our products and need more information and/or hi-res images for media purposes, please send your inquiry to:</p>
                <p>hello@bedaskin.com</p>
                <h2>SALES</h2>
                <p>If you are interested in exploring retail partnerships with us, please contact:</p>
                <p>hello@bedaskin.com</p>
                <h2>CUSTOMER SERVICE</h2>
                <p>We are happy to help you with any question regarding orders, products or returns. Please, contact our customer service at:</p>
                <p>hello@bedaskin.com</p>
                <p>
                    BETTER DAYS<br />
                    12 Jln Kilang Barat<br />
                    #06-01 Singapore 159354<br />
                </p>
            </ContentContainer>
            <BeKindSection />
            <InstagramFeed />
        </Layout>
    )
}

export default Contact;
